import React from 'react'
import { translate as t } from '../i18n'
import Dialog from '@mui/material/Dialog'
import { Button, DialogActions, DialogContent, DialogTitle, Stack } from '@mui/material'
import { LoadingButton } from '@mui/lab'

type Props = {
  title?: any
  message?: any
  open: boolean
  loading?: boolean
  onClose: () => void
  action: () => void
}

export function DialogConfirmation ({ title, message, open, loading, onClose, action }: Props) {
  return (
    <Dialog
      open={open}
      onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Stack direction='row' marginTop={2} alignItems='center' sx={{ maxWidth: '100%', height: '50px' }}>
          {message}
        </Stack>
      </DialogContent>
      <DialogActions sx={{ height: '50px' }}>
        <LoadingButton loading={loading} onClick={action} variant="contained">
          {t('general.btn.confirm')}
        </LoadingButton>
        <Button onClick={onClose} variant="contained" color="secondary">{t('general.btn.dismiss')}</Button>
      </DialogActions>
    </Dialog>
  )
}
